// @flow

import React, { type Node } from 'react';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { TotalAmountOverride } from '../total-amount/components';

export function Sidebar(): Node {
  const features = useAllFeatures();

  return (
    <IfFeature allFeatures={features} wanted="display_receipt_final_amount">
      <TotalAmountOverride />
    </IfFeature>
  );
}
